import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../utils/removeKeys';

/**
  List
 **/

const List = (props) => {
  const { children, type = '', ...rest } = removeKeys(props, ['classes']);
  const menuList = React.Children.map(children, item => {
    return (<li>{item}</li>);
  });
  return (
    <ul
      {...rest}
      {...resolve(props, type)}>
      {menuList}
    </ul>
  );
};

List.propTypes = {
  /** The child content for the list. */
  children: PropTypes.node.isRequired,
  /** CSS Modlues Object */
  classes: PropTypes.object,
  /** The type of list to display. */
  type: PropTypes.oneOf(['menu', 'list']),
  /** Available Style Keys. */
  style: PropTypes.shape({
    /** Style to apply for menu type lists. */
    menu: PropTypes.object,
    /** Style to apply for list type lists. */
    list: PropTypes.object
  })
};
List.displayName = 'List';
List.defaultProps = {
  type: 'list'
};
export default List;
